//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let messageTextAlign = 'center';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
		messageTextAlign = 'left';
	}
	//#endregion

	return {
		outerStyle: ({marginTop} = {}) => {
			let marginTopVal = marginTop ? '3rem' : 0;
			return {
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				height: 'auto',
				padding: `0 ${minimumMarginX}rem`,
				marginTop: marginTopVal,
			};
		},
		messageTextStyle: () => {
			return {
				width: '100%',
			};
		},
		buttonContainerStyle: () => {
			return {
				display: 'flex',
				width: '100%',
				height: 'auto',
				marginTop: '1rem',
			};
		},
		buttonStyle: ({isBack} = {}) => {
			let marginLeft = 0;
			let marginRight = 0;
			if (isBack) {
				marginRight = 'auto';
			} else {
				marginLeft = 'auto';
			}
			return {
				width: '8rem',
				marginLeft: marginLeft,
				marginRight: marginRight,
			};
		},
	};
}

export default Styles;
